import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { generateHTMLString } from '@/src/pdf/templates/publication';
import { convertHtmlToPdf } from '@/src/pdf/utils';

import PUB_MASTERS from './pubmasters.json';
import TYPE_CODES from './typeCodes';

const PublicationAuto = dynamic(() => import('./PublicationAuto'));
const PublicationOther = dynamic(() => import('./PublicationOther'));
const PublicationPDF = dynamic(() => import('./PublicationPDF'));

const Publication = function Publication(props) {
  const { data, loading } = props;
  const { PublicationMasterCode } = data;
  const [pdfExportStatus, setPdfExportStatus] = useState(false);

  if (loading) return null;

  const handleExportToPdf = async (info = {}) => {
    const { contacts, contactPics, hide, list, billNumTitle } = info;
    setPdfExportStatus(true);
    const fileName = `Publication-${data.Headline}.pdf`;
    const html = generateHTMLString({ data, contacts, contactPics, hide, list, billNumTitle });
    await convertHtmlToPdf({ html, fileName }, setPdfExportStatus);
  };

  const { title: pubMasterTitle, url: pubMasterPath } = PublicationMasterCode
    ? PUB_MASTERS[PublicationMasterCode.toString()]
    : { title: '', url: '' };

  const pubprops = {
    pubMasterTitle,
    pubMasterPath,
    handleExportToPdf,
    pdfExportStatus,
    ...props,
  };

  if (TYPE_CODES.OTHER.includes(PublicationMasterCode)) {
    return <PublicationOther {...pubprops} />;
  }

  if (TYPE_CODES.PDF.includes(PublicationMasterCode)) {
    return <PublicationPDF {...pubprops} />;
  }

  return <PublicationAuto {...pubprops} type="publication" />;
};

Publication.propTypes = {
  data: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // this is passed to convince memo to remember/forget
};

Publication.defaultProps = {
  id: null,
};

export default Publication;
